module.exports = __webpack_public_path__ + "static/media/7.38f8a7c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyes/7.png
// module id = 1246
// module chunks = 0